import { QueryClient, QueryClientConfig } from '@tanstack/react-query';

export const createQueryClient = (config?: QueryClientConfig) =>
  new QueryClient({
    ...config,
    defaultOptions: {
      ...config?.defaultOptions,
      queries: {
        staleTime: 600000,
        ...config?.defaultOptions?.queries,
      },
    },
  });
